export const environment = {
  apiUrl: 'https://api-beta.quik-ai.com',
  cmsUrl: 'https://cms-beta.quik-ai.com/',
  storagePrefix: 'eai-share-stable.',
};
